import React, { type FC } from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';

import type { IPrice } from 'api/types';
import { Radio } from 'components/controls';

import styles from 'theme/pages/wise/WiseProduct/components/WisePrices/WisePrices.module.scss';

export type WisePricesProductOptionsProps = {
  prices: IPrice[];
  unitId: number;
  onSelectUnit: (unitId: number) => void;
};

const WisePricesProductOptions: FC<WisePricesProductOptionsProps> = ({
  prices,
  unitId,
  onSelectUnit
}) => (
  <div className={styles.productOptionsContainer}>
    <div className={styles.productOptionsTitle}>
      <Trans>Wybierz opcję</Trans>:
    </div>
    {prices.map((opt) => (
      <div
        key={opt.id}
        className={styles.productOptionItem}
        onClick={() => onSelectUnit(opt.unit_id)}>
        <div className={styles.productOptionLeft}>
          <Radio checked={opt.unit_id === unitId} onClick={() => onSelectUnit(opt.unit_id)} />
          <div className={styles.productOptionMainText}>
            <span
              className={classnames(styles.productOptionLabel, {
                [styles.productOptionLabelSelected]: opt.unit_id === unitId
              })}>
              {opt.unit_name}
            </span>
            <div className={styles.productOptionIlo}>
              <Trans>Ilość</Trans>: {opt.converter}
            </div>
          </div>
        </div>
        <div className={styles.productOptionPrices}>
          <div className={styles.productOptionPriceNet}>
            <Trans>Cena netto</Trans>: {opt.price_net_formatted} {opt.currency}
          </div>
          <div className={styles.productOptionPriceUnit}>
            <Trans>Cena za szt. (netto)</Trans>: {opt.unit_price_net_formatted} {opt.currency}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default WisePricesProductOptions;
